import React, {useState, useEffect} from 'react';
import {Grid , Chip, Typography, List, ListItem, ListItemIcon, ListItemText, Divider, Paper} from '@material-ui/core/';
import {NavigateNext} from '@material-ui/icons';
import { useStyles } from "./style";
import {functions} from 'constants/index'
//REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

import {AccountCircle, Email, Filter1, Today, LocationOn, Call, Wc, Person, InsertComment, Description, HomeWork } from '@material-ui/icons';

function DatosCiudadano(props) {   
    const classes = useStyles()
    const [datosCiudadanoTable, setdatosCiudadanoTable] = useState({
        nombreCompleto:'',
        sexo:'',
        alfabetismo: 0,
        limitaciones:'',
        profesion:0,
        fechaNacimiento:'',
        lugarNacimiento:'',
        fechaNacionaliza:'',
        nroLibroNacimientoDpi:0, nroFolioNacimientoDpi:0, nroPartidaNacimeintoDpi:0, lugarResidenciaRenap:'',
        lugarResidenciaElectoralNacional:'', lugarResidenciaElectoralExtranjero:'', direccionResidenciaRenap:'', direccionResidenciaElectoral:'', telefono:'', email:'',
        nombrePadre:'', nombreMadre:'', observacion:'',        
    });
    const splitDate = (date) => {
        if (date !== null) {
            var arr1 = date.split("-");
            if(arr1[2] !== undefined){
                var arr2 = arr1[2].split("T");
                var finalDate = arr2[0] + "/" + arr1[1] + "/" + arr1[0];
            }
            return finalDate;
          }
    };
    let elements = []
    useEffect(() => {
        if(JSON.stringify(props.datosCiudadanoTable)!=='{}'){
            var lugarNacimientoDepartamento = '', lugarNacimientoMunicipio = '',
            primerNombre='', segundoNombre='', primerApellido="", segundoApellido="", tercerApellido="",
            profesionName = '',
            departamentoResidenciaElectoral = '', paisResidenciaElectoral='', estadoResidenciaElectoral='', ciudadResidenciaElectoral='',
            municipioResidenciaElectoral = '', comunidadResidenciaElectoral='', lugarResidenciaRenapDepartamento='', lugarResidenciaRenapMunicipio='',
            primerNombreMadre='', segundoNombreMadre='', primerApellidoMadre ='', segundoApellidoMadre='', tercerApellidoMadre='',
            primerNombrePadre='', segundoNombrePadre='', primerApellidoPadre ='', segundoApellidoPadre='', tercerApellidoPadre='',
            direccionDeResidencia='', noDeCasa='', zonaDeResidencia='', fechaAsientoNacimiento= ''; 
            // console.log('profesionName: ', props.datosCiudadanoTable)
            if(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.profesionName === null) profesionName = ''
            else profesionName = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.profesionName?.name;

            //lugar de nacimiento
            if(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.departamentoNacimiento === null) lugarNacimientoDepartamento = ''
            else lugarNacimientoDepartamento = props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.departamentoNacimiento?.name;
            if(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.municipioNacimieno === null) lugarNacimientoMunicipio = ''
            else lugarNacimientoMunicipio = props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.municipioNacimieno?.name;
            // lugar de residencia electoral nacional
            if(props.datosCiudadanoTable?.departamentoResidencia === null) departamentoResidenciaElectoral = ''
            else departamentoResidenciaElectoral = props.datosCiudadanoTable?.departamentoResidencia?.name;
            if(props.datosCiudadanoTable?.municipioResidencia === null) municipioResidenciaElectoral = ''
            else municipioResidenciaElectoral = props.datosCiudadanoTable?.municipioResidencia?.name;
            if(props.datosCiudadanoTable?.comunidadResidencia === null) comunidadResidenciaElectoral = ''
            else comunidadResidenciaElectoral = props.datosCiudadanoTable?.comunidadResidencia?.categoriaDescripcion?.descripcionCategoria+', '+props.datosCiudadanoTable?.comunidadResidencia?.descripcionCenVotacion+', '+props.datosCiudadanoTable?.comunidadResidencia?.lugarVotacion;
            // lugar de residencia electoral extranjero
            if(props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.pais === null) paisResidenciaElectoral = ''
            else paisResidenciaElectoral = props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.pais?.nombrePaisCorto;
            if(props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.estadoExtranjero === null) estadoResidenciaElectoral = ''
            else estadoResidenciaElectoral = props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.estadoExtranjero?.nombreDelEstado;
            if(props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.ciudadExtranjero === null) ciudadResidenciaElectoral = ''
            else ciudadResidenciaElectoral = props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.ciudadExtranjero?.nombreDeCiudad;

        // nombre completo del ciudadano
            if(props.datosCiudadanoTable?.primerNombre === null) primerNombre = ''
            else primerNombre = props.datosCiudadanoTable?.primerNombre;

            if(props.datosCiudadanoTable?.segundoNombre === null) segundoNombre = ''
            else segundoNombre = props.datosCiudadanoTable?.segundoNombre;

            if(props.datosCiudadanoTable?.primerApellido === null) primerApellido = ''
            else primerApellido = props.datosCiudadanoTable?.primerApellido;

            if(props.datosCiudadanoTable?.segundoApellido === null) segundoApellido = ''
            else segundoApellido = props.datosCiudadanoTable?.segundoApellido;

            if(props.datosCiudadanoTable?.tercerApellido === null) tercerApellido = ''
            else tercerApellido = props.datosCiudadanoTable?.tercerApellido;
            
        // validamos el nombre de la nombreMadre
            if(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNomMadre === null) primerNombreMadre = ''
            else primerNombreMadre = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNomMadre;

            if(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNomMadre === null) segundoNombreMadre = ''
            else segundoNombreMadre = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNomMadre;

            if(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApeMadre === null) primerApellidoMadre = ''
            else primerApellidoMadre = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApeMadre;

            if(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApeMadre === null) segundoApellidoMadre = ''
            else segundoApellidoMadre = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApeMadre

            // validamos el nombre del padre
            if(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNomPadre === null) primerNombrePadre = ''
            else primerNombrePadre = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNomPadre  
            if(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNomPadre === null) segundoNombrePadre = ''
            else segundoNombrePadre =  props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNomPadre
            if(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApePadre === null) primerApellidoPadre = ''
            else primerApellidoPadre = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApePadre
            if(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApePadre === null) segundoApellidoPadre = ''
            else segundoApellidoPadre = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApePadre

            if(props.datosCiudadanoTable?.direccion === null) direccionDeResidencia = ''
            else direccionDeResidencia = props.datosCiudadanoTable?.direccion
            if(props.datosCiudadanoTable?.numeroCasa === null) noDeCasa = ''
            else noDeCasa = ', No. Casa/Lote: '+ props.datosCiudadanoTable?.numeroCasa
            if(props.datosCiudadanoTable?.numeroZona === null) zonaDeResidencia = ''
            else zonaDeResidencia = ', Zona: '+ props.datosCiudadanoTable?.numeroZona

            //LUGAR DE RESIDENCIA RENAP
            // if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.departamentoVecindad === null) lugarResidenciaRenapDepartamento = '';
            // else lugarResidenciaRenapDepartamento= props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.departamentoVecindad.name
            // if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.municipioVecindad === null) lugarResidenciaRenapMunicipio = '';
            // else lugarResidenciaRenapMunicipio= props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.municipioVecindad.name;

            // if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.fechaAdientoNacDpi === null) fechaAsientoNacimiento = '';
            // else fechaAsientoNacimiento= functions.splitDate(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.fechaAdientoNacDpi);

            setdatosCiudadanoTable({
                nombreCompleto: primerNombre+' '+segundoNombre+ ', ' +primerApellido+ ' '+ segundoApellido + ', '+tercerApellido,
                sexo: props.datosCiudadanoTable?.genero,
                alfabetismo: props.datosCiudadanoTable?.alfabetismo,
                limitaciones: props.datosCiudadanoTable?.noVidente,
                profesion: profesionName,
                fechaNacimiento: props.datosCiudadanoTable?.fechaNacimiento,
                fechaAsientoNacimiento: fechaAsientoNacimiento,
                lugarNacimiento: lugarNacimientoDepartamento+', '+lugarNacimientoMunicipio,
                fechaNacionaliza: props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.fechaNacionalizacion,
                nroLibroNacimientoDpi: props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.nroLibroNacimientoDpi,
                nroFolioNacimientoDpi: props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.nroFolioNacimientoDpi,
                nroPartidaNacimeintoDpi: props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.nroPartidaNacimientoDpi,
                lugarResidenciaElectoralNacional: departamentoResidenciaElectoral+', '+municipioResidenciaElectoral +', '+comunidadResidenciaElectoral,
                lugarResidenciaElectoralExtranjero: paisResidenciaElectoral+', '+ estadoResidenciaElectoral+', '+ ciudadResidenciaElectoral,
                // lugarResidenciaRenap: lugarResidenciaRenapDepartamento+', '+lugarResidenciaRenapMunicipio,
                // direccionResidenciaRenap: props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.complementoDpiSolicitud.direccionRenap ,
                direccionResidenciaElectoral: direccionDeResidencia+noDeCasa+zonaDeResidencia,
                telefono: props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.telefono,
                email: props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.email,
                nombrePadre: primerNombrePadre+' '+segundoNombrePadre+', '+primerApellidoPadre+' '+segundoApellidoPadre,
                nombreMadre: primerNombreMadre+' '+segundoNombreMadre+', '+primerApellidoMadre+' '+segundoApellidoMadre,
                observacion: props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.observaciones,
            })
        }
        // console.log('datosCiudadanoTable: ', props.datosCiudadanoTable)
    },[props.datosCiudadanoTable])
    return (
        <Grid container >
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>DATOS DEL CIUDADANO</strong> <Divider /></div>
            </Grid >             
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText}  primary="Nombre completo: " />
                    <ListItemIcon className={classes.colorIcon}><AccountCircle/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip}  label={datosCiudadanoTable.nombreCompleto} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText}  primary="Sexo: " />
                    <ListItemIcon className={classes.colorIcon} ><Wc/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                { datosCiudadanoTable.sexo === 1 ? <Chip variant="outlined" className={classes.colorChip} label="Masculino"/> 
                    : <Chip variant="outlined" className={classes.colorChip} label="Femenino"  /> 
                }
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Alfabetismo: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                { datosCiudadanoTable.alfabetismo === 0 ? <Chip variant="outlined" className={classes.colorChip} label="No lee, No escribe"/>
                    : datosCiudadanoTable.alfabetismo === 1 ? <Chip variant="outlined" className={classes.colorChip} label="Si lee"/> 
                    : datosCiudadanoTable.alfabetismo === 2 ? <Chip variant="outlined" className={classes.colorChip} label="Si escribe"/> 
                    : <Chip variant="outlined" className={classes.colorChip} label="Si lee, Si escribe"/> 
                }                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Vista: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >
            <Grid item xs={3}>
                { datosCiudadanoTable.limitaciones === 1 ? <Chip variant="outlined" className={classes.colorChip} label="No vidente"  /> 
                    : datosCiudadanoTable.limitaciones === 0 ? <Chip variant="outlined" className={classes.colorChip} label="Vidente"  /> 
                    : ''
                }
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Fecha de Nacimiento: " />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={functions.dateFormatGeneral(datosCiudadanoTable.fechaNacimiento)}  />                                
            </Grid >                            
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Lugar de Nacimiento: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.lugarNacimiento} />                                
            </Grid >                 
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Libro: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroLibroNacimientoDPI ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroLibroNacimientoDPI : '')}/>                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Folio: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroFolioNacimientoDPI ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroFolioNacimientoDPI : '')}/>                                
            </Grid >                        
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Partida: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>                                    
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroPartidaNacimientoDPI ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroPartidaNacimientoDPI : '')} />                                
            </Grid >                               
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Teléfono: " />
                    <ListItemIcon className={classes.colorIcon}><Call/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.telefono} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Lugar de Residencia Electoral: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                {
                    (datosCiudadanoTable.lugarResidenciaElectoralExtranjero === ", , ") ? <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.lugarResidenciaElectoralNacional} />
                    : <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.lugarResidenciaElectoralExtranjero} />
                }
            </Grid >                         
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem} >
                    <ListItemText className={classes.rootListItemText} primary="Nombre del Padre: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} 
                    label={(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNombrePadre ? props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNombrePadre : '')
                        +' '+(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNombrePadre ? props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNombrePadre : '')+', '+
                            (props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApellidoPadre ? props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApellidoPadre : '' )
                        +' '+(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApellidoPadre ? props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApellidoPadre: '' )}/>                                
            </Grid >            
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Dirección de Residencia Electoral: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                {
                    (datosCiudadanoTable.lugarResidenciaElectoralExtranjero === ", , ") ? <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.direccionResidenciaElectoral} />
                    : <Chip variant="outlined" className={classes.colorChip} label={''} />
                }                
            </Grid >                            
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Nombre de la Madre: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} 
                    label={(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNombreMadre ? props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNombreMadre : '')
                        +' '+ (props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNombreMadre ? props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNombreMadre :'')+', '+
                        (props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApellidoMadre ? props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApellidoMadre : '') 
                        +' '+(props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApellidoMadre ? props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApellidoMadre : '')} />                                
            </Grid >               
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Correo electrónico: " />
                    <ListItemIcon className={classes.colorIcon}><Email/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.email} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Profesión: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={datosCiudadanoTable.profesion}  />                                
            </Grid >                                         
        </Grid>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadano);